import cn from 'classnames';
import * as React from 'react';
import { compose } from 'recompose';
import { createStyles } from '@material-ui/core/styles';
import { FontIcon, withBaseProps } from '@topconagriculture/react-components';
const styles = (theme) => createStyles({
    titleWrapper: {
        textTransform: 'uppercase',
        fontSize: theme.font.size.mediumBig,
        color: theme.color.font.dark,
        lineHeight: '0.94',
    },
    titleStepNumber: {
        position: 'relative',
        bottom: '5px',
        marginRight: 5,
    },
    titleLabel: {
        position: 'relative',
        bottom: '5px',
    },
});
const PanelTitle = (props) => {
    const { children, classes, icon, stepNumber, titleClassName } = props;
    return (React.createElement("div", { className: classes.titleWrapper },
        React.createElement(FontIcon, { color: 'black', size: 22, marginRight: 10, iconName: icon }),
        (stepNumber || stepNumber === 0) && React.createElement("span", { className: classes.titleStepNumber },
            stepNumber,
            "."),
        React.createElement("span", { className: cn(classes.titleLabel, titleClassName) }, children)));
};
export default compose(withBaseProps({ styles }))(PanelTitle);
//# sourceMappingURL=PanelTitle.js.map